import styled, { css } from "styled-components";

export const UserAddressTextFieldRoot = styled.div(
    () => css`
        --address-input-padding-right: 2.5rem;
        position: relative;
        input {
            margin-right: var(--address-input-padding-right);
        }
    `,
);

export const ScanCameraIconWrapper = styled.div(
    ({ theme }) => css`
        cursor: pointer;
        position: absolute;
        width: var(--address-input-padding-right);
        right: 0;
        top: 2.25rem;
        height: 3.75rem;
        display: flex;
        align-items: center;
        .Icon.Icon.Icon.Icon.Icon {
            font-size: 1.5rem;
            color: ${theme.palette.primary};
        }
    `,
);
